var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 890",
    d: "M6 5L14.8377 2.05409C16.3934 1.53552 18 2.69347 18 4.33333V4.33333",
    stroke: "#0D121C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34624293"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 17,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 17,
    rx: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 17,
    rx: 2.5,
    stroke: "#0D121C"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2390",
    cx: 12,
    cy: 11,
    r: 3.5,
    stroke: "#0D121C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2391",
    d: "M13.5 11C13.5 12.0438 13.2874 12.964 12.967 13.6048C12.6316 14.2755 12.2609 14.5 12 14.5C11.7391 14.5 11.3684 14.2755 11.033 13.6048C10.7126 12.964 10.5 12.0438 10.5 11C10.5 9.95622 10.7126 9.03598 11.033 8.39518C11.3684 7.72447 11.7391 7.5 12 7.5C12.2609 7.5 12.6316 7.72447 12.967 8.39518C13.2874 9.03598 13.5 9.95622 13.5 11Z",
    stroke: "#0D121C"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 576",
    x1: 9,
    y1: 11.5,
    x2: 15,
    y2: 11.5,
    stroke: "#0D121C"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 578",
    x1: 9,
    y1: 17.5,
    x2: 15,
    y2: 17.5,
    stroke: "#0D121C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passport-icon.b2e5fefa66a6a7e846bb1d703d0b4117.svg";
export { ForwardRef as ReactComponent };